import { MENSAJE_COMPRA } from "../data/config";
import { useWhatsApp } from "../hooks/useWhatsApp";
import IconoWhatsApp from "./ui/IconoWhatsApp";

// Boton flotante siempre visible para facilitar el contacto rapido.
const BotonFlotanteWhatsApp = () => {
  const { abrirWhatsApp } = useWhatsApp();

  return (
    <button
      type="button"
      onClick={() => abrirWhatsApp(MENSAJE_COMPRA)}
      aria-label="Escríbenos por WhatsApp"
      className="group animate-fab-in fixed bottom-6 right-6 z-50 flex items-center"
    >
      {/* Etiqueta que se despliega al pasar el cursor (oculta en móvil) */}
      <span className="pointer-events-none mr-3 hidden translate-x-2 rounded-full bg-charcoal/90 px-4 py-2 text-sm font-semibold text-white opacity-0 shadow-card transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100 sm:block">
        Escríbenos
      </span>

      {/* Núcleo del botón con anillos de pulso */}
      <span className="relative flex h-16 w-16 items-center justify-center">
        {/* Anillos animados que emanan del botón */}
        <span className="animate-pulse-ring absolute inset-0 rounded-full bg-[#25D366]" aria-hidden="true" />
        <span
          className="animate-pulse-ring absolute inset-0 rounded-full bg-[#25D366]"
          style={{ animationDelay: "1.1s" }}
          aria-hidden="true"
        />

        {/* Botón sólido con degradado e icono */}
        <span className="relative flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-[#25D366] to-[#128C7E] text-white shadow-card-hover ring-1 ring-white/30 transition-transform duration-300 group-hover:scale-110 group-active:scale-95">
          <IconoWhatsApp className="text-3xl drop-shadow-sm" />
        </span>
      </span>
    </button>
  );
};

export default BotonFlotanteWhatsApp;
